import request from '@/utils/request'

/**
 * 查询退货订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryRefundOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryRefundOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核退货订单
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditStoreOrderCartReturn(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartReturn.auditStoreOrderCartReturn',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}